/**
 * Support Actions
 * NgRx actions for support tickets state management
 */
import { createAction, props } from '@ngrx/store';
import { Ticket, TicketStats, TicketFilters, CreateTicketRequest, TicketMessage } from '../models/support.models';

// Load Stats
export const loadStats = createAction('[Support] Load Stats');
export const loadStatsSuccess = createAction('[Support] Load Stats Success', props<{ stats: TicketStats }>());
export const loadStatsFailure = createAction('[Support] Load Stats Failure', props<{ error: string }>());

// Load Tickets
export const loadTickets = createAction(
  '[Support] Load Tickets',
  props<{ filters: TicketFilters; page: number; pageSize: number }>()
);
export const loadTicketsSuccess = createAction(
  '[Support] Load Tickets Success',
  props<{ tickets: Ticket[]; total: number }>()
);
export const loadTicketsFailure = createAction('[Support] Load Tickets Failure', props<{ error: string }>());

// Load Single Ticket
export const loadTicket = createAction('[Support] Load Ticket', props<{ ticketId: string }>());
export const loadTicketSuccess = createAction('[Support] Load Ticket Success', props<{ ticket: Ticket }>());
export const loadTicketFailure = createAction('[Support] Load Ticket Failure', props<{ error: string }>());

// Create Ticket
export const createTicket = createAction('[Support] Create Ticket', props<{ request: CreateTicketRequest }>());
export const createTicketSuccess = createAction('[Support] Create Ticket Success', props<{ ticket: Ticket }>());
export const createTicketFailure = createAction('[Support] Create Ticket Failure', props<{ error: string }>());

// Add Message
export const addMessage = createAction(
  '[Support] Add Message',
  props<{ ticketId: string; content: string; attachments?: File[] }>()
);
export const addMessageSuccess = createAction('[Support] Add Message Success', props<{ message: TicketMessage }>());
export const addMessageFailure = createAction('[Support] Add Message Failure', props<{ error: string }>());

// Close Ticket
export const closeTicket = createAction('[Support] Close Ticket', props<{ ticketId: string }>());
export const closeTicketSuccess = createAction('[Support] Close Ticket Success', props<{ ticket: Ticket }>());
export const closeTicketFailure = createAction('[Support] Close Ticket Failure', props<{ error: string }>());

// Reopen Ticket
export const reopenTicket = createAction('[Support] Reopen Ticket', props<{ ticketId: string }>());
export const reopenTicketSuccess = createAction('[Support] Reopen Ticket Success', props<{ ticket: Ticket }>());
export const reopenTicketFailure = createAction('[Support] Reopen Ticket Failure', props<{ error: string }>());

// Update Filters
export const updateFilters = createAction('[Support] Update Filters', props<{ filters: Partial<TicketFilters> }>());

// Pagination
export const changePage = createAction('[Support] Change Page', props<{ page: number }>());
export const changePageSize = createAction('[Support] Change Page Size', props<{ pageSize: number }>());

// Clear
export const clearSelectedTicket = createAction('[Support] Clear Selected Ticket');
export const clearError = createAction('[Support] Clear Error');
export const clearSuccessMessage = createAction('[Support] Clear Success Message');

